import { faker } from '@faker-js/faker';
import { IPointInfo, IPointInvoice } from '@contexts/PointContext/types';

class PointInfo {
  pointInfo;
  constructor() {
    this.pointInfo = this.createMock();
  }
  createMock(): IPointInfo {
    const pointName = `CCOB Point`;
    const totalAmount = faker.number.int({ min: 1000000, max: 10000000000 });
    const balance = totalAmount - faker.number.int({ min: 0, max: 1000000 });
    return {
      id: faker.string.uuid(),
      blockchain: 'AERGO',
      creatorId: faker.string.uuid(),
      description: faker.commerce.productDescription(),
      imageUrl: faker.image.urlPlaceholder({
        height: 640,
        width: 640,
        text: pointName,
      }),
      name: pointName,
      relatedPageUrl: 'cccv.to',
      symbol: 'CP',
      totalAmount,
      balance,
    };
  }
  get() {
    return this.pointInfo;
  }
}

export const pointInfo = new PointInfo();

class PointInvoiceData {
  currentPage = 1;
  initalData;
  data;
  totalElementCount;
  totalPage;
  limit;
  constructor({ size }: { size: number }) {
    this.initalData = Array.from({ length: size }, this.createBadgeIssueObject);
    this.data = this.initalData;
    this.totalElementCount = size;
    this.totalPage = Math.ceil(size / this.limit);
  }

  createBadgeIssueObject(): IPointInvoice {
    return {
      id: faker.string.uuid(),
      tokenId: faker.person.firstName(),
      date: faker.date.recent().toISOString(),
      amount: faker.number.int({ min: -10, max: 10 }),
      ci: faker.string.uuid(),
      txId: faker.string.octal({ length: 40, prefix: '0x' }),
      description: faker.commerce.productDescription(),
    };
  }

  get({ requestPageNumber }: { requestPageNumber: number }) {
    const startIndex = (requestPageNumber - 1) * this.limit;
    const endIndex = startIndex + this.limit;

    return {
      currentPage: requestPageNumber,
      data: this.data.slice(startIndex, endIndex),
      totalElementCount: this.totalElementCount,
      totalPage: this.totalPage,
    };
  }

  set({ limit }: { limit }) {
    this.limit = limit;
    this.totalPage = Math.ceil(this.totalElementCount / this.limit);
  }
}

export const pointInvoiceData = new PointInvoiceData({ size: 39 });

class PointHistory {
  data;
  totalElementCount;
  constructor({ size }: { size: number }) {
    this.data = Array.from({ length: size }, this.createMock);
  }

  createMock() {
    return {
      date: faker.date.recent().toISOString(),
      balance: faker.number.int({ min: 10, max: 100 }),
      changedAmount: faker.number.int({ min: -10, max: 10 }),
      description: faker.commerce.productDescription(),
    };
  }

  get({ limit, cursor = 0 }: { limit: number; cursor?: number }) {
    const end = cursor ? cursor : this.data.length;
    const start = Math.max(end - limit, 0);

    return {
      nextCursor: this.data.length - start,
      content: this.data.slice(start, end),
      totalElementCount: this.data.length,
    };
  }
}

export const pointHistory = new PointHistory({ size: 11 });
